import { useContext, useMemo } from "react"
import UserContext from "../contexts/UserContext/context"

const ADMIN_GROUP = '#Stjórnendur'

export const useUser = () => {
  const { user } = useContext(UserContext)

  const isAdmin = useMemo(() => user.groups.includes(ADMIN_GROUP), [user.groups])

  return {
    isAdmin
  }
}
